import "./SignatureExperiences.module.css";
import Header from "@/reusable_sections/Header";
import TheInvestment from "./sections/TheInvestment";
import TheGlowProcess from "./sections/TheGlowProcess";
import Footer from "@/reusable_sections/Footer";
export default function SignatureExperiencesPage() {
  return <div>
      <Header />
      <TheInvestment />
      <TheGlowProcess />
      <Footer />
    </div>;
}